export default "__VITE_ASSET__DY22SjVH__"